// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1702619723218
      var cssReload = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  